import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Box = styled.div<{ $width?: number; $height?: number }>`
    width: 100%;
    max-width: ${({ $width }) => ($width ? `${$width}px` : "340px")};
    height: ${({ $height }) => ($height ? `${$height}px` : "108px")};
    border: 2px dashed ${colors.primary};
    border-radius: ${radii.base};
    background: rgba(25, 118, 210, 0.02);
    color: ${colors.primary};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;

    &:hover {
        background: rgba(25, 118, 210, 0.06);
    }
`;

export const Title = styled.span`
    font-size: 0.875rem;
    font-weight: 600;
`;

export const Hint = styled.span`
    font-size: 11px;
    color: ${colors.fieldLabel};
`;
